export default {"src":"/_next/static/media/hero.9335e949.svg","height":700,"width":1200,"blurWidth":0,"blurHeight":0};